import {Component, Inject, OnDestroy} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {EmployeeService} from "@services/admin/employee.service";
import {AbstractClass} from "@classes/abstract.class";
import {Employee} from "@models/employee";
import {ActivatedRoute, Router} from "@angular/router";
import {LanguageFacade} from "@redux/facades/language.facade";

@Component({
  standalone: false,
  selector: 'app-tenant-dialog',
  templateUrl: './tenant-dialog.component.html',
  styleUrls: ['./tenant-dialog.component.scss']
})
export class TenantDialogComponent implements OnDestroy {
  public title = 'title';
  public showData: boolean = false;
  public myClass: AbstractClass | null = null;
  public lang: string | null = null;

  constructor(
    public dialogRef: MatDialogRef<TenantDialogComponent>,
    public service: EmployeeService,
    public router: Router,
    public languageFacade: LanguageFacade,
    private _Activatedroute: ActivatedRoute,
    //@Inject(MAT_DIALOG_DATA) public data: { user: Employee }
  ) {
    // this.service.modelClass.set(data.user);
    this.title = 'cms.components.tenant.select-tenant';
    this.getProfile();
  }

  // tslint:disable-next-line:typedef
  public ngOnDestroy() { }

  public ngOnInit() {
    this.showData = true;
  }

  public getProfile = () => {
    this.service.getProfile().then(
      (data: any) => {
        if (data !== false) {
          console.log(this.service.modelClass);
          // this.router.navigateByUrl('/admin/' + this.lang + '/home');
        }
      }
    );
  }

  public setTenant = () => {
    this.service.sendCode("").then(
      (data: any) => {
        if (data !== false) {
          this.router.navigateByUrl('/admin/' + this.lang + '/home');
        }
      }
    );
  }

  public cancel = () => {
    this.dialogRef.close();
  }
}
